module.exports = __webpack_public_path__ + "img/easy_bg05.042cf706.png";